(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConnectTeacherToGroupController', ConnectTeacherToGroupController);

    ConnectTeacherToGroupController.$inject = ['debug', 'API', 'i18n', '$scope',];

    function ConnectTeacherToGroupController(debug, API, i18n, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.loading = false;
        vm.groups = [];
        vm.groupIdToJoin = 0;
        vm.groupsToRender = [];

        activate();

        function activate() {
            vm.teacher = $scope.placeholders.teacher;
            vm.groups = $scope.placeholders.groups;

            angular.forEach(vm.groups, function(group) {
                vm.groupsToRender.push({
                    value: group.id,
                    label: group.name,
                    subLabel: group.id,
                });
            });
        }

        function submit() {
            API.User.addToGroup({
                id: vm.teacher.id,
                target: vm.groupIdToJoin
            }).$promise.then(function (response) {
                if (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    vm.resolve();
                } else {
                    window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                }
                $scope.$parent.close();
            }, function () {
                window.toast({ message: i18n.get('FAILED'), type: 'danger' });
            });
        }

    }
})();